import { styled } from "styled-components";

import { colorCSS, fontSizes, radius, shadow } from "../../styles";
import { redundantCssFromKebab } from "../../styles/redundant-css";

export type ButtonProps = {
    appearance: "shadow" | "outline";
};

export const Button = styled.button<ButtonProps>`
    ${redundantCssFromKebab("align-items", "center")}
    ${redundantCssFromKebab("background", `${colorCSS("N0")}`)}
    ${redundantCssFromKebab("border-radius", `${radius.button}`)}
    ${redundantCssFromKebab("color", `${colorCSS("N800")}`)}
    ${redundantCssFromKebab("display", "flex")}
    ${redundantCssFromKebab("font-size", `${fontSizes.xs}`)}
    ${redundantCssFromKebab("gap", "0.5rem")}
    ${redundantCssFromKebab("justify-content", "center")}
    ${redundantCssFromKebab("text-align", "left")}
    ${redundantCssFromKebab("width", "100%")}

    ${({ appearance }: { appearance: string }) =>
        appearance === "shadow"
            ? `
      border: 0;
      box-shadow: ${shadow.small};
      font-weight: 500;
      padding: 0.5rem;
      `
            : `
      border: 1px solid ${colorCSS("N800")};
      padding: 0.75rem;
      text-decoration: none;
      `}

    &:focus, &:hover {
        background-color: ${colorCSS("N10")};
        color: inherit;
        text-decoration: none;
    }

    &:focus-visible {
        outline-offset: 1px;
    }

    svg {
        display: block;
        width: 18px;
        height: 18px;
    }
`;
